<div [formGroup]="form">
  <div class="form-group row">
    <label for="startTime"
           class="col-1 control-label required">{{'i18n.shared.time-picker.from' | translate}}:</label>
    <div class="col-3 d-flex align-items-center">
      <div>
        <ejs-timepicker id="startTime"
                        name="startTime"
                        formControlName="startTime"
                        enableMask="true"
                        step="15"
                        showClearButton="true"
                        floatLabelType="Never"
                        [strictMode]="timepickerStrictMode"
                        [format]="customFormat"></ejs-timepicker>
        <app-error-messages [control]="form.controls.startTime"></app-error-messages>
      </div>
    </div>
    <label for="duration"
           class="col-1 control-label required">
      {{'i18n.shared.time-picker.duration' | translate}}:
    </label>
    <div class="col-3 d-flex align-items-center">
      <div>
        <app-duration-input id="duration"
                            name="duration"
                            formControlName="duration"></app-duration-input>
        <app-error-messages [control]="form.controls.duration"></app-error-messages>
      </div>
    </div>
    <label class="col-1 control-label">{{'i18n.shared.time-picker.to'| translate}}:</label>
    <label class="col-3 control-label">{{endTimeStr}}</label>
  </div>
  @if (showSlider) {
    <div class="row">
      <div class="col-12">
        <app-duration-time-slider [startTime]="form.controls.startTime.value"
                                  [duration]="form.controls.duration.value"
                                  [maxDuration]="maxDuration"
                                  (durationChange)="durationChange($event)"></app-duration-time-slider>
      </div>
    </div>
  }
</div>
